/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_Base_Url_PlaceholderInputs */

const en_byoa_base_url_placeholder = /** @type {(inputs: Byoa_Base_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://your-ai-service.com/v1`)
};

const id_byoa_base_url_placeholder = /** @type {(inputs: Byoa_Base_Url_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://layanan-ai-mu.com/v1`)
};

/**
* | output |
* | --- |
* | "https://your-ai-service.com/v1" |
*
* @param {Byoa_Base_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_base_url_placeholder = /** @type {((inputs?: Byoa_Base_Url_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Base_Url_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_base_url_placeholder(inputs)
	return en_byoa_base_url_placeholder(inputs)
});